export enum CarrierTypes {
  "INTERNATIONAL" = "INTERNATIONAL",
  "UK" = "UK",
}
